import { LOADING_STATUS } from "@/helpers/loadingStatus";
import GlobalMixins from "@/mixins/GlobalMixins";
import httpClient from "@/http/httpClient";
import store from "@/store";
import _ from "lodash";
import { toast } from "@starline-security/component-library";
const module = {
  namespaced: true,
  state: () => {
    return {
      loadingStatus: "",
      result: [],
      search: "",
      itemsPerPage: 20,
      currentPage: 1,
      hasMorePages: false,
      searchItems: ["email", "subject"],
      selectedItem: [],
      selectedIds: [],
      startDate: "",
      endDate: "",
    };
  },
  getters: {
    hasNextPage(state) {
      return state.hasMorePages; //state.totalPages > state.currentPage;
    },
    getParams(state) {
      const params = {};
      if (state.search.toString().trim()) {
        params["query"] = state.search.toString().trim();
      }

      if (state.searchItems && state.searchItems.length > 0) {
        params["search_in"] = state.searchItems.map((i) => i).join(",");
      }

      if (state.startDate && state.startDate !== "") {
        params["start_date"] = state.startDate;
      }

      if (state.endDate && state.endDate !== "") {
        params["end_date"] = state.endDate;
      }

      params["batch_size"] = state.itemsPerPage;
      params["page"] = state.currentPage;

      return params;
    },
  },
  mutations: {
    reset(state) {
      state.currentPage = 1;
      state.itemsPerPage = 10;
      state.searchItems = ["email", "subject", "payload"];
      state.result = [];
      state.startDate = "";
      state.endDate = "";
    },
    setItemsPerPage(state, payload) {
      state.currentPage = 1;
      state.result = [];
      state.itemsPerPage = payload;
    },
    setSearchTerm(state, payload) {
      state.currentPage = 1;
      state.result = [];
      state.search = payload;
    },
    setLoadingStatus(state, payload) {
      state.loadingStatus = payload;
    },
    loadNextPage(state, payload) {
      state.currentPage = state.currentPage + 1;
    },
    setHasMorePages(state, payload) {
      let result = false;
      if (payload !== null) {
        result = true;
      }
      state.hasMorePages = result;
    },
    setResult(state, payload) {
      if (state.currentPage === 1) state.result = [];
      state.result = state.result.concat(payload);
    },
    setSelectedSearchElements(state, payload) {
      state.searchItems = [];
      state.searchItems = payload;
    },
    setSelectedItem(state, payload) {
      state.selectedItem = [];
      state.selectedItem = payload;
    },
    setSelectedIds(state, payload) {
      state.selectedIds = [];
      state.selectedIds = payload;
    },
    setStartDate(state, payload) {
      state.startDate = "";
      state.startDate = payload;
    },
    setEndDate(state, payload) {
      state.endDate = "";
      state.endDate = payload;
    },
  },
  actions: {
    async fetchAllWithFilters({ commit, state, dispatch, getters }) {
      if (
        [LOADING_STATUS.REFRESHING, LOADING_STATUS.FETCHING].includes(
          state.loadingStatus
        )
      ) {
        return true;
      }

      commit(
        "setLoadingStatus",
        !_.isEmpty(state.result)
          ? LOADING_STATUS.REFRESHING
          : LOADING_STATUS.FETCHING
      );
      try {
        const response = await httpClient.get("settings/email-log/get", {
          params: getters.getParams,
        });
        commit("setResult", response.data.data);
        commit("setHasMorePages", response.data.next_page_url);
        setTimeout(() => {
          commit("setLoadingStatus", LOADING_STATUS.COMPLETED);
        });
        return true;
      } catch (error) {
        console.error("Error on Fetch customer: ", error);
        commit("setLoadingStatus", LOADING_STATUS.FAILED);
        store.commit("errorsModal/openModal", error.response.data.errors);
        return false;
      }
    },

    async resendEmail({ state, commit, getters, dispatch }, payload) {
      store.commit("preloader/preloader", true);
      try {
        const data = {
          ids: state.selectedIds,
        };
        const response = await httpClient.post(
          `settings/email-log/resend`,
          data
        );
        dispatch("fetchAllWithFilters");
        // store.commit("successFeedback/show", {
        //   title: "SUCCESSS",
        //   description: "Email has been successfully sent.",
        // });
        toast.success(`Email has been successfully sent.`);
      } catch (error) {
        // GlobalMixins.showErrorMessage(error)
        toast.error(`Something went wrong. Please try again.`);
      } finally {
        store.commit("preloader/preloader", false);
      }
    },

    async forwardEmail({ state, commit, getters, dispatch }, payload) {
      let isSuccess = false;
      store.commit("preloader/preloader", true);
      try {
        const data = {
          ids: state.selectedIds,
          email: payload.email,
        };

        const response = await httpClient.post(
          `settings/email-log/forward`,
          data
        );
        dispatch("fetchAllWithFilters");
        // store.commit("successFeedback/show", {
        //   title: "SUCCESSS",
        //   description: `Email has been successfully forward to ${payload.email}.`,
        // });
        toast.success(
          `Email has been successfully forward to ${payload.email}.`,
          {
            action: { label: "" },
          }
        );
        isSuccess = true;
      } catch (error) {
        // GlobalMixins.showErrorMessage(error);
        toast.error(`Something went wrong. Please try again.`, {
          action: { label: "" },
        });
      } finally {
        store.commit("preloader/preloader", false);
      }
      return isSuccess;
    },
  },
};

export default module;
